// extracted by mini-css-extract-plugin
export default {"header":"style_header__n-Kfy","title":"style_title__xgjPu","deleteButton":"style_deleteButton__jw1-a"};